import { RouterModule, Routes } from '@angular/router';

import {
  UploadPhotoComponent, LoadProductComponent, OrderCompletedComponent, CampionarioCompletedComponent,
  SelectProductsComponent, SelectDimensionsComponent, PreviewComponent, CartComponent, CheckoutComponent,
  CheckoutCampionarioComponent, PageCropComponent, NoContentComponent, SlideParameterComponent
} from './pages';

const routes: Routes = [
  { path: '', redirectTo: 'select-products', pathMatch: 'full' },
  {
    path: 'load-product/:idProduct', component: LoadProductComponent, data: {
      id: 0, sort: 0, title: 'Precarica prodotto', isMenu: false
    }
  },
  {
    path: 'load-image/:urlFileCatalog', component: LoadProductComponent, data: {
      id: 0, sort: 0, title: 'Precarica immagine da Catalogo', isMenu: false
    }
  },
  { path: 'order-completed/:idTransaction', component: OrderCompletedComponent },
  { path: 'campionario-completed/:idTransaction', component: CampionarioCompletedComponent },
  { path: 'checkout-campionario', component: CheckoutCampionarioComponent },

  { path: 'select-products', component: SelectProductsComponent, data: { id: 1, sort: 1, title: 'Seleziona prodotto', isMenu: true } },
  { path: 'upload-photo', component: UploadPhotoComponent, data: { id: 2, sort: 2, title: 'Carica la tua foto', isMenu: true } },
  { path: 'preview', component: PreviewComponent, data: { id: 4, sort: 99, title: 'Anteprima', isMenu: true } },
  { path: 'cart', component: CartComponent, data: { id: 5, sort: 5, title: 'Carrello', isMenu: false } },
  { path: 'checkout', component: CheckoutComponent, data: { id: 6, sort: 6, title: 'Checkout', isMenu: false } },
  { path: 'pagecrop', component: PageCropComponent, data: { id: 7, sort: 7, title: 'PageCropComponent', isMenu: false } },
  {
    path: 'slide-parameter/Formato', component: SelectDimensionsComponent, data: {
      id: 3, sort: 3, title: 'Seleziona Dimensioni', isMenu: false
    }
  },
  {
    path: 'slide-parameter/:paramsTable', component: SlideParameterComponent, data: {
      id: 8, sort: 8, title: 'SlideParameterComponent', isMenu: false
    }
  },
  { path: '**', component: NoContentComponent }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts